/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiUserAddUserPost } from '../fn/user/api-user-add-user-post';
import { ApiUserAddUserPost$Params } from '../fn/user/api-user-add-user-post';
import { apiUserAllUserPost } from '../fn/user/api-user-all-user-post';
import { ApiUserAllUserPost$Params } from '../fn/user/api-user-all-user-post';
import { apiUserDeleteGet } from '../fn/user/api-user-delete-get';
import { ApiUserDeleteGet$Params } from '../fn/user/api-user-delete-get';
import { apiUserLoginMailOtpGet } from '../fn/user/api-user-login-mail-otp-get';
import { ApiUserLoginMailOtpGet$Params } from '../fn/user/api-user-login-mail-otp-get';
import { apiUserOptPartiesGet } from '../fn/user/api-user-opt-parties-get';
import { ApiUserOptPartiesGet$Params } from '../fn/user/api-user-opt-parties-get';
import { apiUserRegisterMailChallengePost } from '../fn/user/api-user-register-mail-challenge-post';
import { ApiUserRegisterMailChallengePost$Params } from '../fn/user/api-user-register-mail-challenge-post';
import { apiUserRegisterOtpMailPost } from '../fn/user/api-user-register-otp-mail-post';
import { ApiUserRegisterOtpMailPost$Params } from '../fn/user/api-user-register-otp-mail-post';
import { apiUserRegisterOtpSmsPost } from '../fn/user/api-user-register-otp-sms-post';
import { ApiUserRegisterOtpSmsPost$Params } from '../fn/user/api-user-register-otp-sms-post';
import { apiUserRegisterSmsChallengePost } from '../fn/user/api-user-register-sms-challenge-post';
import { ApiUserRegisterSmsChallengePost$Params } from '../fn/user/api-user-register-sms-challenge-post';
import { apiUserUpdatePost } from '../fn/user/api-user-update-post';
import { ApiUserUpdatePost$Params } from '../fn/user/api-user-update-post';
import { apiUserUserInfoGet } from '../fn/user/api-user-user-info-get';
import { ApiUserUserInfoGet$Params } from '../fn/user/api-user-user-info-get';
import { ManageUserProfile } from '../models/manage-user-profile';
import { ManageUserProfileApiRespModel } from '../models/manage-user-profile-api-resp-model';
import { OtpRes } from '../models/otp-res';
import { PartyOptionRes } from '../models/party-option-res';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiUserRegisterOtpMailPost()` */
  static readonly ApiUserRegisterOtpMailPostPath = '/api/User/register-otp-mail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserRegisterOtpMailPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserRegisterOtpMailPost$Response(params?: ApiUserRegisterOtpMailPost$Params, context?: HttpContext): Observable<StrictHttpResponse<OtpRes>> {
    return apiUserRegisterOtpMailPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserRegisterOtpMailPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserRegisterOtpMailPost(params?: ApiUserRegisterOtpMailPost$Params, context?: HttpContext): Observable<OtpRes> {
    return this.apiUserRegisterOtpMailPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<OtpRes>): OtpRes => r.body)
    );
  }

  /** Path part for operation `apiUserRegisterMailChallengePost()` */
  static readonly ApiUserRegisterMailChallengePostPath = '/api/User/register-mail-challenge';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserRegisterMailChallengePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserRegisterMailChallengePost$Response(params?: ApiUserRegisterMailChallengePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiUserRegisterMailChallengePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserRegisterMailChallengePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserRegisterMailChallengePost(params?: ApiUserRegisterMailChallengePost$Params, context?: HttpContext): Observable<void> {
    return this.apiUserRegisterMailChallengePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiUserRegisterOtpSmsPost()` */
  static readonly ApiUserRegisterOtpSmsPostPath = '/api/User/register-otp-sms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserRegisterOtpSmsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserRegisterOtpSmsPost$Response(params?: ApiUserRegisterOtpSmsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<OtpRes>> {
    return apiUserRegisterOtpSmsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserRegisterOtpSmsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserRegisterOtpSmsPost(params?: ApiUserRegisterOtpSmsPost$Params, context?: HttpContext): Observable<OtpRes> {
    return this.apiUserRegisterOtpSmsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<OtpRes>): OtpRes => r.body)
    );
  }

  /** Path part for operation `apiUserRegisterSmsChallengePost()` */
  static readonly ApiUserRegisterSmsChallengePostPath = '/api/User/register-sms-challenge';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserRegisterSmsChallengePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserRegisterSmsChallengePost$Response(params?: ApiUserRegisterSmsChallengePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiUserRegisterSmsChallengePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserRegisterSmsChallengePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserRegisterSmsChallengePost(params?: ApiUserRegisterSmsChallengePost$Params, context?: HttpContext): Observable<void> {
    return this.apiUserRegisterSmsChallengePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiUserOptPartiesGet()` */
  static readonly ApiUserOptPartiesGetPath = '/api/User/opt/parties';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserOptPartiesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserOptPartiesGet$Response(params?: ApiUserOptPartiesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PartyOptionRes>>> {
    return apiUserOptPartiesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserOptPartiesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserOptPartiesGet(params?: ApiUserOptPartiesGet$Params, context?: HttpContext): Observable<Array<PartyOptionRes>> {
    return this.apiUserOptPartiesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PartyOptionRes>>): Array<PartyOptionRes> => r.body)
    );
  }

  /** Path part for operation `apiUserAddUserPost()` */
  static readonly ApiUserAddUserPostPath = '/api/User/AddUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserAddUserPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserAddUserPost$Response(params?: ApiUserAddUserPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ManageUserProfileApiRespModel>> {
    return apiUserAddUserPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserAddUserPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserAddUserPost(params?: ApiUserAddUserPost$Params, context?: HttpContext): Observable<ManageUserProfileApiRespModel> {
    return this.apiUserAddUserPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ManageUserProfileApiRespModel>): ManageUserProfileApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiUserUpdatePost()` */
  static readonly ApiUserUpdatePostPath = '/api/User/Update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserUpdatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserUpdatePost$Response(params?: ApiUserUpdatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<ManageUserProfileApiRespModel>> {
    return apiUserUpdatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserUpdatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserUpdatePost(params?: ApiUserUpdatePost$Params, context?: HttpContext): Observable<ManageUserProfileApiRespModel> {
    return this.apiUserUpdatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ManageUserProfileApiRespModel>): ManageUserProfileApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiUserAllUserPost()` */
  static readonly ApiUserAllUserPostPath = '/api/User/AllUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserAllUserPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserAllUserPost$Response(params?: ApiUserAllUserPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ManageUserProfile>>> {
    return apiUserAllUserPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserAllUserPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiUserAllUserPost(params?: ApiUserAllUserPost$Params, context?: HttpContext): Observable<Array<ManageUserProfile>> {
    return this.apiUserAllUserPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ManageUserProfile>>): Array<ManageUserProfile> => r.body)
    );
  }

  /** Path part for operation `apiUserUserInfoGet()` */
  static readonly ApiUserUserInfoGetPath = '/api/User/UserInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserUserInfoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserUserInfoGet$Response(params?: ApiUserUserInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ManageUserProfile>> {
    return apiUserUserInfoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserUserInfoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserUserInfoGet(params?: ApiUserUserInfoGet$Params, context?: HttpContext): Observable<ManageUserProfile> {
    return this.apiUserUserInfoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ManageUserProfile>): ManageUserProfile => r.body)
    );
  }

  /** Path part for operation `apiUserDeleteGet()` */
  static readonly ApiUserDeleteGetPath = '/api/User/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserDeleteGet$Response(params?: ApiUserDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiUserDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserDeleteGet(params?: ApiUserDeleteGet$Params, context?: HttpContext): Observable<void> {
    return this.apiUserDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiUserLoginMailOtpGet()` */
  static readonly ApiUserLoginMailOtpGetPath = '/api/User/LoginMailOTP';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserLoginMailOtpGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserLoginMailOtpGet$Response(params?: ApiUserLoginMailOtpGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ManageUserProfile>> {
    return apiUserLoginMailOtpGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserLoginMailOtpGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserLoginMailOtpGet(params?: ApiUserLoginMailOtpGet$Params, context?: HttpContext): Observable<ManageUserProfile> {
    return this.apiUserLoginMailOtpGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ManageUserProfile>): ManageUserProfile => r.body)
    );
  }

}
